export default __webpack_public_path__ + "static/media/nginx.e86cc851.svg";